import FeatureFlagInterfaceV1 from './FeatureFlagInterfaceV1';
import { FeatureFlagInterfaceV1Type } from '@clientos/types';

export { createNoopFeatureFlagsInterface } from './NoopInterface';

let featureFlagInterfaceV1: FeatureFlagInterfaceV1;

export function getFeatureFlagInterfaceV1(): FeatureFlagInterfaceV1Type {
  return featureFlagInterfaceV1.getInterface();
}

export default async function initializeFeatureFlagInterfaceV1(): Promise<FeatureFlagInterfaceV1Type> {
  if (featureFlagInterfaceV1) return featureFlagInterfaceV1.getInterface();
  featureFlagInterfaceV1 = new FeatureFlagInterfaceV1();

  return featureFlagInterfaceV1.getInterface();
}
